<template>
  <div class="container">
    <div v-for="(item,index) in rewardOrderList" :key="index" class="rewardList">
      <div style="display: flex;">
        <img :src="item.avatar" alt="" class="avatar">
        <div>
          <div class="name">{{item.userName}}</div>
          <div class="time">{{item.createTime}}</div>
        </div>
      </div>
      <div class="amount">{{item.rewardAmount}}元</div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'

  export default {
    name: "RewardList",
    data() {
      return {
        rewardOrderList: [],
        deliveryId: '',
      }
    },
    created(){
      this.deliveryId = window.localStorage.getItem('deliveryId');
      this.getRewardInfo();
    },
    methods: {
      getRewardInfo(){
        let _this = this;
        actions.getWeixinRewardList(_this, {deliveryId: _this.deliveryId}, function (data) {
          _this.rewardOrderList = data.list;
        }, function (data) {
          _this.$messagebox.alert(data.data.message, '')
        })
      }
    }

  }
</script>

<style scoped>
  .container{
    background: #fff;
    min-height: 100vh;
    padding: 0 .3rem;
  }
  .rewardList{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #F2F2F2;
    padding: .4rem 0;
  }
  .avatar{
    width: .8rem;
    height: .8rem;
    border-radius: 50%;
  }
  .name{
    /*font-weight: 700;*/
    font-size: .28rem;
    color: #2F2F2F;
    margin-left: .24rem;
  }
  .time{
    font-size: .22rem;
    color: #797979;
    margin-left: .24rem;
    margin-top: .04rem;
  }
  .amount{
    font-weight: 700;
    font-size: .28rem;
    color: #F93A2F;
  }
</style>



// WEBPACK FOOTER //
// RewardList.vue?e3806dc6